const searchParams = window.location.search;

const getParams = () => {
  const searchParams = window.location.search;
  const urlParams = new URLSearchParams(searchParams);
  const allParams = {};
  urlParams.forEach((value, key) => {
    allParams[key] = value;
  });
  return allParams;
};

const handleParams = (key, value) => {
  const searchParams = window.location.search;
  const urlParams = new URLSearchParams(searchParams);
  if (key) {
    urlParams.delete(key);
    urlParams.append(key, value);
  }
  return "?" + urlParams.toString();
};

const removeMetricsParam = () => {
  const searchParams = window.location.search;
  const urlParams = new URLSearchParams(searchParams);
  urlParams.delete("metrics");
  const newSearch = urlParams.toString();
  const newUrl = window.location.pathname + (newSearch ? "?" + newSearch : "");
  return newUrl;
};

const clearWellnessReportPreference = () => {
  localStorage.removeItem("wellnessReportDontShow");
};

const isProd = window.location.origin === "https://report.seniorlife.ai";

// Backend returns the numeric reading under `value` for most metrics but under
// `time` for sitToStandTime / standToSitTime. Read both so call sites don't
// have to special-case by metric name.
const getMetricReading = (metric) => {
  if (!metric || typeof metric !== "object") return null;
  return metric.value ?? metric.time ?? null;
};

const formatReportGender = (gender, locale) => {
  if (!gender) return "";

  const value = String(gender).trim();
  if (
    !String(locale || "")
      .toLowerCase()
      .startsWith("ja")
  ) {
    return value;
  }

  return value.replace(/^す\s*(?=女性|男性|その他|不明|未回答)/u, "").trim();
};

export {
  getParams,
  searchParams,
  handleParams,
  removeMetricsParam,
  clearWellnessReportPreference,
  isProd,
  getMetricReading,
  formatReportGender,
};
